import { __decorate, __param } from 'tslib';
import { Inject, ElementRef, Component, ChangeDetectionStrategy, NgZone, ViewChild, Input, HostBinding, NgModule } from '@angular/core';
import { ANIMATION_FRAME, WINDOW } from '@ng-web-apis/common';
import { tuiZonefree, px, TuiDestroyService, tuiPure, TuiHoveredModule, TuiActiveZoneModule } from '@taiga-ui/cdk';
import { TuiPointerHintDirective } from '@taiga-ui/core/directives/pointer-hint';
import { TUI_ANIMATION_OPTIONS, TUI_MEDIA } from '@taiga-ui/core/tokens';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { tuiFadeIn } from '@taiga-ui/core/animations';
import { TuiHintDirective } from '@taiga-ui/core/directives/hint';
import { TuiHintService } from '@taiga-ui/core/services';
import { CommonModule } from '@angular/common';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/cdk';
import * as ɵngcc3 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc4 from '@taiga-ui/core/services';
import * as ɵngcc5 from 'rxjs';

function TuiHintsHostComponent_tui_hint_box_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const text_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(text_r3);
} }
function TuiHintsHostComponent_tui_hint_box_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tui-hint-box", 1);
    ɵngcc0.ɵɵlistener("tuiHoveredChange", function TuiHintsHostComponent_tui_hint_box_0_Template_tui_hint_box_tuiHoveredChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const hint_r1 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onHovered($event, hint_r1); });
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, TuiHintsHostComponent_tui_hint_box_0_ng_template_2_Template, 2, 1, "ng-template");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const hint_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@tuiFadeIn", ctx_r0.animation)("hint", hint_r1)("tuiActiveZoneParent", hint_r1.activeZone);
    ɵngcc0.ɵɵattribute("id", hint_r1.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("content", hint_r1.content);
} }
const _c0 = ["arrow"];
const _c1 = ["hint", ""];
function TuiHintBoxComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 2, 3);
} }
const _c2 = ["*"];
let TuiHintsHostComponent = class TuiHintsHostComponent {
    constructor(options, elementRef, hints$) {
        this.options = options;
        this.elementRef = elementRef;
        this.hints$ = hints$;
        this.animation = Object.assign({ value: '' }, this.options);
    }
    get clientRect() {
        return this.elementRef.nativeElement.getBoundingClientRect();
    }
    onHovered(hovered, directive) {
        if (directive instanceof TuiHintDirective) {
            directive.componentHovered$.next(hovered);
        }
    }
};
TuiHintsHostComponent.ɵfac = function TuiHintsHostComponent_Factory(t) { return new (t || TuiHintsHostComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_ANIMATION_OPTIONS), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(TuiHintService)); };
TuiHintsHostComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiHintsHostComponent, selectors: [["tui-hints-host"]], hostAttrs: ["aria-live", "polite"], decls: 2, vars: 3, consts: [["role", "tooltip", 3, "hint", "tuiActiveZoneParent", "tuiHoveredChange", 4, "ngFor", "ngForOf"], ["role", "tooltip", 3, "hint", "tuiActiveZoneParent", "tuiHoveredChange"], ["polymorpheus-outlet", "", 3, "content"], [1, "t-text"]], template: function TuiHintsHostComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiHintsHostComponent_tui_hint_box_0_Template, 3, 5, "tui-hint-box", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.hints$));
    } }, directives: function () { return [ɵngcc1.NgForOf, TuiHintBoxComponent, ɵngcc2.TuiActiveZoneDirective, ɵngcc2.TuiHoveredDirective, ɵngcc3.PolymorpheusOutletComponent]; }, pipes: function () { return [ɵngcc1.AsyncPipe]; }, styles: ["[_nghost-%COMP%]{position:fixed;bottom:0;left:0;width:100%;height:0}.t-text[_ngcontent-%COMP%]{white-space:pre-wrap}"], data: { animation: [tuiFadeIn] }, changeDetection: 0 });
TuiHintsHostComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [TUI_ANIMATION_OPTIONS,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: TuiHintService, decorators: [{ type: Inject, args: [TuiHintService,] }] }
];
TuiHintsHostComponent = __decorate([ __param(0, Inject(TUI_ANIMATION_OPTIONS)),
    __param(1, Inject(ElementRef)),
    __param(2, Inject(TuiHintService))
], TuiHintsHostComponent);

const SPACE = 8;
const BORDER_WIDTH = 1;
const LEFT_PADDING = 16;
const TOP_PADDING = 12;
const ARROW_SIZE = 8;
const ARROW_OFFSET = 16;
const ARROWHEAD_OFFSET = ARROW_OFFSET + (ARROW_SIZE * Math.sqrt(2)) / 2;
const reverseDirectionsVertical = {
    'top-left': 'bottom-left',
    'top-right': 'bottom-right',
    'bottom-left': 'top-left',
    'bottom-right': 'top-right',
    left: 'right',
    right: 'left',
};
const reverseDirectionsHorizontal = {
    'top-left': 'top-right',
    'top-right': 'top-left',
    'bottom-left': 'bottom-right',
    'bottom-right': 'bottom-left',
    left: 'right',
    right: 'left',
};
// TODO: consider abstracting UI and move to CDK, split hint and overflow
// Ambient type cannot be used without dynamic https://github.com/angular/angular/issues/23395
// @dynamic
let TuiHintBoxComponent = class TuiHintBoxComponent {
    constructor(animationFrame$, destroy$, ngZone, elementRef, windowRef, media, hintsHost) {
        this.elementRef = elementRef;
        this.windowRef = windowRef;
        this.media = media;
        this.hintsHost = hintsHost;
        animationFrame$
            .pipe(tuiZonefree(ngZone), takeUntil(destroy$))
            .subscribe(() => this.calculatePosition());
    }
    get isUntouchable() {
        return this.hint instanceof TuiPointerHintDirective;
    }
    get mode() {
        return this.hint.mode;
    }
    get isMobile() {
        return this.windowRef.innerWidth <= this.media.mobile;
    }
    /**
     * Calculates wrapper position.
     * Styles are set directly to avoid visual shake of element
     */
    calculatePosition() {
        if (this.mode !== 'overflow') {
            this.calculateCoordinates();
        }
        else {
            this.setOverflowStyles();
        }
    }
    calculateCoordinates() {
        if (this.isMobile) {
            this.calculateMobileCoordinates();
            return;
        }
        const hostRect = this.hint.getElementClientRect();
        const portalRect = this.hintsHost.clientRect;
        const tooltip = this.elementRef.nativeElement;
        const { style } = tooltip;
        const tooltipRect = tooltip.getBoundingClientRect();
        const isHostLong = hostRect.width > ARROWHEAD_OFFSET * 2;
        const directions = [
            'left',
            'right',
            'bottom-left',
            'bottom-right',
            'top-left',
            'top-right',
        ];
        let top = 0;
        let left = 0;
        let { direction } = this.hint;
        const horizontalTop = hostRect.top + hostRect.height / 2 - tooltipRect.height / 2 - portalRect.top;
        const horizontalLeft = hostRect.left - tooltipRect.width - SPACE - portalRect.left;
        const horizontalRight = hostRect.left + hostRect.width + SPACE - portalRect.left;
        const verticalBottom = hostRect.bottom + SPACE - portalRect.top;
        const verticalTop = hostRect.top - tooltipRect.height - SPACE - portalRect.top;
        const verticalRight = isHostLong
            ? hostRect.left - portalRect.left
            : hostRect.left + hostRect.width / 2 - ARROWHEAD_OFFSET - portalRect.left;
        const verticalLeft = isHostLong
            ? hostRect.left - tooltipRect.width + hostRect.width - portalRect.left
            : hostRect.left -
                tooltipRect.width +
                hostRect.width / 2 +
                ARROWHEAD_OFFSET -
                portalRect.left;
        directions.splice(directions.indexOf(direction), 1);
        // eslint-disable-next-line no-constant-condition
        while (true) {
            switch (direction) {
                case 'left':
                    top = horizontalTop;
                    left = horizontalLeft;
                    break;
                case 'right':
                    top = horizontalTop;
                    left = horizontalRight;
                    break;
                case 'top-right':
                    top = verticalTop;
                    left = verticalRight;
                    break;
                case 'top-left':
                    top = verticalTop;
                    left = verticalLeft;
                    break;
                case 'bottom-right':
                    top = verticalBottom;
                    left = verticalRight;
                    break;
                case 'bottom-left':
                    top = verticalBottom;
                    left = verticalLeft;
                    break;
            }
            const verticalFit = top + portalRect.top > SPACE &&
                top + tooltipRect.height + SPACE + portalRect.top <
                    this.windowRef.innerHeight;
            const horizontalFit = left > SPACE &&
                left + tooltipRect.width + SPACE + portalRect.left < portalRect.width;
            if (directions.length === 0 || (verticalFit && horizontalFit)) {
                break;
            }
            direction = verticalFit
                ? reverseDirectionsHorizontal[direction]
                : reverseDirectionsVertical[direction];
            direction =
                directions.splice(directions.indexOf(direction), 1)[0] || direction;
        }
        style.top = px(top);
        style.left = px(left);
        tooltip.setAttribute('data-tui-host-direction', direction);
    }
    calculateMobileCoordinates() {
        const hostRect = this.hint.getElementClientRect();
        const portalRect = this.hintsHost.clientRect;
        const tooltip = this.elementRef.nativeElement;
        const { style } = tooltip;
        const tooltipRect = tooltip.getBoundingClientRect();
        const verticalTop = hostRect.top - tooltipRect.height - SPACE - portalRect.top;
        const verticalBottom = hostRect.bottom + SPACE - portalRect.top;
        const verticalTopFit = verticalTop + portalRect.top > SPACE &&
            hostRect.top < this.windowRef.innerHeight;
        const verticalBottomFit = hostRect.bottom > 0 &&
            hostRect.bottom + 2 * SPACE + tooltipRect.height < this.windowRef.innerHeight;
        const direction = (this.hint.direction.includes('top') && verticalTopFit) || !verticalBottomFit
            ? 'top'
            : 'bottom';
        const attemptedLeft = portalRect.left + hostRect.left + hostRect.width / 2 - tooltipRect.width / 2;
        const left = Math.max(attemptedLeft + tooltipRect.width + SPACE > portalRect.right
            ? portalRect.right - SPACE - tooltipRect.width
            : attemptedLeft, SPACE * 2);
        style.left = px(left);
        style.top = direction === 'top' ? px(verticalTop) : px(verticalBottom);
        if (this.arrow) {
            this.arrow.nativeElement.style.left = px(hostRect.left <= SPACE * 2 && hostRect.width > ARROW_OFFSET * 2
                ? ARROW_OFFSET
                : hostRect.left + hostRect.width / 2 - left - ARROW_SIZE / 2);
        }
        tooltip.setAttribute('data-tui-host-direction', direction);
    }
    setOverflowStyles() {
        const hostRect = this.hint.getElementClientRect();
        const { style } = this.elementRef.nativeElement;
        style.top = px(hostRect.top - window.innerHeight - TOP_PADDING - BORDER_WIDTH);
        style.left = px(hostRect.left - LEFT_PADDING - BORDER_WIDTH);
        style.width = px(hostRect.width + LEFT_PADDING * 2 + BORDER_WIDTH * 2);
    }
};
TuiHintBoxComponent.ɵfac = function TuiHintBoxComponent_Factory(t) { return new (t || TuiHintBoxComponent)(ɵngcc0.ɵɵdirectiveInject(ANIMATION_FRAME), ɵngcc0.ɵɵdirectiveInject(TuiDestroyService), ɵngcc0.ɵɵdirectiveInject(NgZone), ɵngcc0.ɵɵdirectiveInject(ElementRef), ɵngcc0.ɵɵdirectiveInject(WINDOW), ɵngcc0.ɵɵdirectiveInject(TUI_MEDIA), ɵngcc0.ɵɵdirectiveInject(TuiHintsHostComponent)); };
TuiHintBoxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiHintBoxComponent, selectors: [["tui-hint-box", "hint", ""]], viewQuery: function TuiHintBoxComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.arrow = _t.first);
    } }, hostVars: 3, hostBindings: function TuiHintBoxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-mode", ctx.mode);
        ɵngcc0.ɵɵclassProp("_untouchable", ctx.isUntouchable);
    } }, inputs: { hint: "hint" }, features: [ɵngcc0.ɵɵProvidersFeature([TuiDestroyService])], attrs: _c1, ngContentSelectors: _c2, decls: 3, vars: 1, consts: [["class", "t-arrow", 4, "ngIf"], ["automation-id", "tui-hint-box__tooltip", 1, "t-tooltip"], [1, "t-arrow"], ["arrow", ""]], template: function TuiHintBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TuiHintBoxComponent_div_0_Template, 2, 0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMobile);
    } }, directives: [ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]{position:absolute;top:0;left:0;max-width:18rem;min-height:var(--tui-height-m);padding:.75rem 1rem;background:var(--tui-primary);border-radius:var(--tui-radius-l);color:var(--tui-primary-text);box-sizing:border-box}[_nghost-%COMP%]   .t-arrow[_ngcontent-%COMP%], [_nghost-%COMP%]:not([data-mode=overflow]):before{content:'';position:absolute;width:.5rem;height:.5rem;border-radius:.125rem;box-sizing:border-box;background-color:inherit;transform:rotate(45deg)}[data-tui-host-direction=top][_nghost-%COMP%]   .t-arrow[_ngcontent-%COMP%]{bottom:-.25rem}[data-tui-host-direction=bottom][_nghost-%COMP%]   .t-arrow[_ngcontent-%COMP%]{top:-.25rem}[data-tui-host-direction=bottom][_nghost-%COMP%]:before, [data-tui-host-direction=top][_nghost-%COMP%]:before{display:none}[data-tui-host-direction=top-left][_nghost-%COMP%]:before, [data-tui-host-direction=top-right][_nghost-%COMP%]:before{bottom:-.25rem}[data-tui-host-direction=bottom-left][_nghost-%COMP%]:before, [data-tui-host-direction=bottom-right][_nghost-%COMP%]:before{top:-.25rem}[data-tui-host-direction=bottom-left][_nghost-%COMP%]:before, [data-tui-host-direction=top-left][_nghost-%COMP%]:before{right:1.075rem}[data-tui-host-direction=bottom-right][_nghost-%COMP%]:before, [data-tui-host-direction=top-right][_nghost-%COMP%]:before{left:1.075rem}[data-tui-host-direction=left][_nghost-%COMP%]:before, [data-tui-host-direction=right][_nghost-%COMP%]:before{top:50%;margin-top:-.25rem}[data-tui-host-direction=left][_nghost-%COMP%]:before{right:-.25rem}[data-tui-host-direction=right][_nghost-%COMP%]:before{left:-.25rem}[data-mode=error][_nghost-%COMP%]{background-color:var(--tui-error-fill)}[data-mode=onDark][_nghost-%COMP%], [data-mode=overflow][_nghost-%COMP%]{box-shadow:0 .5rem 1rem rgba(0,0,0,.16);border:1px solid var(--tui-base-03);background-color:var(--tui-base-01);color:var(--tui-text-01)}[data-mode=onDark][_nghost-%COMP%]:before, [data-mode=overflow][_nghost-%COMP%]:before{border:1px solid var(--tui-base-03)}[data-mode=onDark][data-tui-host-direction=left][_nghost-%COMP%]:before, [data-mode=overflow][data-tui-host-direction=left][_nghost-%COMP%]:before{border-left-color:transparent;border-bottom-color:transparent}[data-mode=onDark][data-tui-host-direction=right][_nghost-%COMP%]:before, [data-mode=overflow][data-tui-host-direction=right][_nghost-%COMP%]:before{border-right-color:transparent;border-top-color:transparent}[data-mode=onDark][data-tui-host-direction=top-left][_nghost-%COMP%]:before, [data-mode=onDark][data-tui-host-direction=top-right][_nghost-%COMP%]:before, [data-mode=overflow][data-tui-host-direction=top-left][_nghost-%COMP%]:before, [data-mode=overflow][data-tui-host-direction=top-right][_nghost-%COMP%]:before{border-left-color:transparent;border-top-color:transparent}[data-mode=onDark][data-tui-host-direction=bottom-left][_nghost-%COMP%]:before, [data-mode=onDark][data-tui-host-direction=bottom-right][_nghost-%COMP%]:before, [data-mode=overflow][data-tui-host-direction=bottom-left][_nghost-%COMP%]:before, [data-mode=overflow][data-tui-host-direction=bottom-right][_nghost-%COMP%]:before{border-right-color:transparent;border-bottom-color:transparent}[data-mode=overflow][_nghost-%COMP%]{max-width:none}._untouchable[_nghost-%COMP%]{pointer-events:none}.t-tooltip[_ngcontent-%COMP%]{font:var(--tui-font-text-s);word-wrap:break-word}[data-mode=overflow][_nghost-%COMP%]   .t-tooltip[_ngcontent-%COMP%]{font:inherit}"], changeDetection: 0 });
TuiHintBoxComponent.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [ANIMATION_FRAME,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TuiDestroyService,] }] },
    { type: NgZone, decorators: [{ type: Inject, args: [NgZone,] }] },
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] },
    { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [TUI_MEDIA,] }] },
    { type: TuiHintsHostComponent, decorators: [{ type: Inject, args: [TuiHintsHostComponent,] }] }
];
__decorate([
    ViewChild('arrow')
], TuiHintBoxComponent.prototype, "arrow", void 0);
__decorate([
    Input()
], TuiHintBoxComponent.prototype, "hint", void 0);
__decorate([
    tuiPure,
    HostBinding('class._untouchable')
], TuiHintBoxComponent.prototype, "isUntouchable", null);
__decorate([
    HostBinding('attr.data-mode')
], TuiHintBoxComponent.prototype, "mode", null);
TuiHintBoxComponent = __decorate([ __param(0, Inject(ANIMATION_FRAME)),
    __param(1, Inject(TuiDestroyService)),
    __param(2, Inject(NgZone)),
    __param(3, Inject(ElementRef)),
    __param(4, Inject(WINDOW)),
    __param(5, Inject(TUI_MEDIA)),
    __param(6, Inject(TuiHintsHostComponent))
], TuiHintBoxComponent);

let TuiHintBoxModule = class TuiHintBoxModule {
};
TuiHintBoxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiHintBoxModule });
TuiHintBoxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiHintBoxModule_Factory(t) { return new (t || TuiHintBoxModule)(); }, imports: [[CommonModule]] });

let TuiHintsHostModule = class TuiHintsHostModule {
};
TuiHintsHostModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiHintsHostModule });
TuiHintsHostModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiHintsHostModule_Factory(t) { return new (t || TuiHintsHostModule)(); }, imports: [[
            CommonModule,
            PolymorpheusModule,
            TuiHoveredModule,
            TuiHintBoxModule,
            TuiActiveZoneModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiHintsHostComponent, [{
        type: Component,
        args: [{
                selector: 'tui-hints-host',
                template: "<tui-hint-box\n    *ngFor=\"let hint of hints$ | async\"\n    role=\"tooltip\"\n    [@tuiFadeIn]=\"animation\"\n    [attr.id]=\"hint.id\"\n    [hint]=\"hint\"\n    [tuiActiveZoneParent]=\"hint.activeZone\"\n    (tuiHoveredChange)=\"onHovered($event, hint)\"\n>\n    <div polymorpheus-outlet [content]=\"hint.content\">\n        <ng-template let-text>\n            <span class=\"t-text\">{{ text }}</span>\n        </ng-template>\n    </div>\n</tui-hint-box>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                animations: [tuiFadeIn],
                host: {
                    'aria-live': 'polite'
                },
                styles: [":host{position:fixed;bottom:0;left:0;width:100%;height:0}.t-text{white-space:pre-wrap}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [TUI_ANIMATION_OPTIONS]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: ɵngcc4.TuiHintService, decorators: [{
                type: Inject,
                args: [TuiHintService]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiHintBoxComponent, [{
        type: Component,
        args: [{
                selector: 'tui-hint-box[hint]',
                template: "<!-- @bad TODO: Refactor to use this arrow in all cases -->\n<div *ngIf=\"isMobile\" #arrow class=\"t-arrow\"></div>\n<div automation-id=\"tui-hint-box__tooltip\" class=\"t-tooltip\">\n    <ng-content></ng-content>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [TuiDestroyService],
                styles: [":host{position:absolute;top:0;left:0;max-width:18rem;min-height:var(--tui-height-m);padding:.75rem 1rem;background:var(--tui-primary);border-radius:var(--tui-radius-l);color:var(--tui-primary-text);box-sizing:border-box}:host .t-arrow,:host:not([data-mode=overflow]):before{content:'';position:absolute;width:.5rem;height:.5rem;border-radius:.125rem;box-sizing:border-box;background-color:inherit;transform:rotate(45deg)}:host[data-tui-host-direction=top] .t-arrow{bottom:-.25rem}:host[data-tui-host-direction=bottom] .t-arrow{top:-.25rem}:host[data-tui-host-direction=bottom]:before,:host[data-tui-host-direction=top]:before{display:none}:host[data-tui-host-direction=top-left]:before,:host[data-tui-host-direction=top-right]:before{bottom:-.25rem}:host[data-tui-host-direction=bottom-left]:before,:host[data-tui-host-direction=bottom-right]:before{top:-.25rem}:host[data-tui-host-direction=bottom-left]:before,:host[data-tui-host-direction=top-left]:before{right:1.075rem}:host[data-tui-host-direction=bottom-right]:before,:host[data-tui-host-direction=top-right]:before{left:1.075rem}:host[data-tui-host-direction=left]:before,:host[data-tui-host-direction=right]:before{top:50%;margin-top:-.25rem}:host[data-tui-host-direction=left]:before{right:-.25rem}:host[data-tui-host-direction=right]:before{left:-.25rem}:host[data-mode=error]{background-color:var(--tui-error-fill)}:host[data-mode=onDark],:host[data-mode=overflow]{box-shadow:0 .5rem 1rem rgba(0,0,0,.16);border:1px solid var(--tui-base-03);background-color:var(--tui-base-01);color:var(--tui-text-01)}:host[data-mode=onDark]:before,:host[data-mode=overflow]:before{border:1px solid var(--tui-base-03)}:host[data-mode=onDark][data-tui-host-direction=left]:before,:host[data-mode=overflow][data-tui-host-direction=left]:before{border-left-color:transparent;border-bottom-color:transparent}:host[data-mode=onDark][data-tui-host-direction=right]:before,:host[data-mode=overflow][data-tui-host-direction=right]:before{border-right-color:transparent;border-top-color:transparent}:host[data-mode=onDark][data-tui-host-direction=top-left]:before,:host[data-mode=onDark][data-tui-host-direction=top-right]:before,:host[data-mode=overflow][data-tui-host-direction=top-left]:before,:host[data-mode=overflow][data-tui-host-direction=top-right]:before{border-left-color:transparent;border-top-color:transparent}:host[data-mode=onDark][data-tui-host-direction=bottom-left]:before,:host[data-mode=onDark][data-tui-host-direction=bottom-right]:before,:host[data-mode=overflow][data-tui-host-direction=bottom-left]:before,:host[data-mode=overflow][data-tui-host-direction=bottom-right]:before{border-right-color:transparent;border-bottom-color:transparent}:host[data-mode=overflow]{max-width:none}:host._untouchable{pointer-events:none}.t-tooltip{font:var(--tui-font-text-s);word-wrap:break-word}:host[data-mode=overflow] .t-tooltip{font:inherit}"]
            }]
    }], function () { return [{ type: ɵngcc5.Observable, decorators: [{
                type: Inject,
                args: [ANIMATION_FRAME]
            }] }, { type: ɵngcc5.Observable, decorators: [{
                type: Inject,
                args: [TuiDestroyService]
            }] }, { type: ɵngcc0.NgZone, decorators: [{
                type: Inject,
                args: [NgZone]
            }] }, { type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }, { type: Window, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [TUI_MEDIA]
            }] }, { type: TuiHintsHostComponent, decorators: [{
                type: Inject,
                args: [TuiHintsHostComponent]
            }] }]; }, { isUntouchable: [{
            type: HostBinding,
            args: ['class._untouchable']
        }], mode: [{
            type: HostBinding,
            args: ['attr.data-mode']
        }], arrow: [{
            type: ViewChild,
            args: ['arrow']
        }], hint: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiHintBoxModule, { declarations: function () { return [TuiHintBoxComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TuiHintBoxComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiHintBoxModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [TuiHintBoxComponent],
                exports: [TuiHintBoxComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiHintsHostModule, { declarations: function () { return [TuiHintsHostComponent]; }, imports: function () { return [CommonModule,
        PolymorpheusModule,
        TuiHoveredModule, TuiHintBoxModule, TuiActiveZoneModule]; }, exports: function () { return [TuiHintsHostComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiHintsHostModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PolymorpheusModule,
                    TuiHoveredModule,
                    TuiHintBoxModule,
                    TuiActiveZoneModule,
                ],
                declarations: [TuiHintsHostComponent],
                exports: [TuiHintsHostComponent],
                entryComponents: [TuiHintsHostComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiHintBoxComponent, TuiHintBoxModule, TuiHintsHostComponent, TuiHintsHostModule };

//# sourceMappingURL=taiga-ui-core-components-hints-host.js.map